<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<div id="photo-viewer-container"></div>
